import React, { Component } from 'react';
import { formatAmount } from 'src/Common/utils';
import { Link } from 'react-router-dom';

const NotAvailable = () =>(
    <small>Não Disponível</small>
)

export default class TableRow extends Component {
    render(){
        const title = this.props.title || {};
        const order = this.props.order || {};
        const portalOrder = order.portalOrder || {}
        var type = this.props.type || {};
        const description = this.props.description || {};
        const amount = this.props.amount || {};
        
        switch(type){
            case 'custom':
                type = 'Avulso';
                break;
            case 'fare':
                type = 'Taxa';
                break;
            case 'bill':
                type = 'Boleto'
                break;
        }

        return (
            <tr>
                <td>{(title) ? title: <NotAvailable/>}</td>
                <td>{(order) ? <Link to={`/vendas/${portalOrder.id}`}>{order.protocol}</Link> : <NotAvailable/>}</td>
                <td>{(type) ? type: <NotAvailable/>}</td>
                <td>{(description) ? description: <NotAvailable/>}</td>
                <td>{(amount) ? formatAmount(amount): <NotAvailable/>}</td>
            </tr>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Items/Table/TableRow.js